import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, limit } from 'firebase/firestore';
import { Phone, Award, ShieldCheck, Zap } from 'lucide-react';
import './ActionSection.css';
import { db } from '../firebase/firebase-config';

const ActionSection = () => {
  const [contactInfo, setContactInfo] = useState(null);

  useEffect(() => {
    const fetchActionContact = async () => {
      try {
        const q = query(collection(db, "settings"), limit(1));
        const snap = await getDocs(q);
        if (!snap.empty) {
          setContactInfo(snap.docs[0].data());
        }
      } catch (error) {
        console.error("CTA verisi çekilemedi:", error);
      }
    };
    fetchActionContact();
  }, []);

  // Tıklanınca aranacak numara (boşluklar temizlenmiş hali)
  const cleanPhone = contactInfo?.phone?.replace(/\s/g, '') || "905520262568";

  return (
    <section className="action-wrapper">
      {/* Güven Bandı */}
      <div className="stats-bar">
        <div className="stat-card">
          <Award size={32} color="#f59e0b" />
          <div>
            <h4>TSE Onaylı</h4>
            <p>Yüksek Kalite Standartları</p>
          </div>
        </div>
        <div className="stat-card">
          <ShieldCheck size={32} color="#f59e0b" />
          <div>
            <h4>Güvenilir Üretim</h4>
            <p>%100 Doğal Hammadde</p>
          </div>
        </div>
        <div className="stat-card">
          <Zap size={32} color="#f59e0b" />
          <div>
            <h4>Hızlı Teslimat</h4>
            <p>Sivas OSB'den Tüm Türkiye'ye</p>
          </div>
        </div>
      </div>

      {/* Harekete Geçirici Mesaj (CTA) */}
      <div className="cta-box">
        <div className="cta-content">
          <h2>Hayvanlarınız İçin En Doğru Rasyonu <br/> <span>Beraber Belirleyelim!</span></h2>
          <p>Sivas Organize Sanayi Bölgesi'ndeki tesislerimizden toplu alımlar ve bayilik fırsatları için uzman ekibimizle iletişime geçin.</p>
        </div>
        <div className="cta-action">
          {/* Butonda numara yazmıyor, sadece metin var ama href dinamik kanka */}
          <a href={`tel:${cleanPhone}`} className="cta-phone-btn">
            <Phone size={24} /> Hemen Arayın
          </a>
        </div>
      </div>
    </section>
  );
};

export default ActionSection;